// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Tabler icons behind the Phosphor names the codebase grew up with.
// Konvo moved from Phosphor to Tabler (2026-09-10). Call sites keep their names and props
// (size, weight, color, mirrored); this module maps them onto @tabler/icons-react. Weight
// becomes stroke width; `fill` picks Tabler's solid variant only for state icons (star, flag,
// pin, active nav, status dots) and a heavier stroke everywhere else, so decorative fills stay
// outlined. Generated by tools/icons/generate-icons.py from tools/icons/phosphor-to-tabler.json.

import type {IconProps as TablerIconProps} from '@tabler/icons-react';
import {
	IconAccessible,
	IconAdjustmentsHorizontal,
	IconAlertCircle,
	IconAlertCircleFilled,
	IconAlertOctagon,
	IconAlertTriangle,
	IconAlertTriangleFilled,
	IconAlignCenter,
	IconAlignLeft,
	IconAlignRight,
	IconAppWindow,
	IconArchive,
	IconArrowBack,
	IconArrowBackUp,
	IconArrowBackUpDouble,
	IconArrowBigUp,
	IconArrowDown,
	IconArrowForwardUp,
	IconArrowLeft,
	IconArrowRight,
	IconArrowsDiagonal,
	IconArrowsDiagonalMinimize,
	IconArrowsDiagonalMinimize2,
	IconArrowsHorizontal,
	IconArrowsMaximize,
	IconArrowsMinimize,
	IconArrowsMove,
	IconArrowsVertical,
	IconArrowUp,
	IconAt,
	IconAtOff,
	IconBadgeCc,
	IconBan,
	IconBell,
	IconBellOff,
	IconBellRinging,
	IconBike,
	IconBold,
	IconBook2,
	IconBookmark,
	IconBowlChopsticks,
	IconBrain,
	IconBrandApple,
	IconBrandGithub,
	IconBrandUbuntu,
	IconBrandWindows,
	IconBriefcase,
	IconBrowser,
	IconBrush,
	IconBug,
	IconBuilding,
	IconBulb,
	IconCake,
	IconCalendar,
	IconCalendarCheck,
	IconCalendarFilled,
	IconCalendarPlus,
	IconCamera,
	IconCameraOff,
	IconChalkboard,
	IconChartBar,
	IconChartLine,
	IconCheck,
	IconChecks,
	IconChevronDown,
	IconChevronLeft,
	IconChevronRight,
	IconChevronUp,
	IconCircle,
	IconCircleCheck,
	IconCircleCheckFilled,
	IconCircleDashed,
	IconCircleDot,
	IconCircleMinus,
	IconCirclePlus,
	IconCircleX,
	IconCircleXFilled,
	IconClipboard,
	IconClipboardText,
	IconClock,
	IconCloud,
	IconCloudFog,
	IconCloudOff,
	IconCloudRain,
	IconCloudSnow,
	IconCloudStorm,
	IconCode,
	IconColorPicker,
	IconCompass,
	IconCopy,
	IconCrown,
	IconDeviceDesktop,
	IconDeviceFloppy,
	IconDeviceGamepad2,
	IconDeviceMobile,
	IconDeviceMobileRotated,
	IconDeviceMobileVibration,
	IconDevices,
	IconDeviceTv,
	IconDots,
	IconDotsVertical,
	IconDownload,
	IconDroplet,
	IconEdit,
	IconEraser,
	IconExclamationMark,
	IconExternalLink,
	IconEye,
	IconEyeOff,
	IconFeather,
	IconFile,
	IconFileCode,
	IconFileMusic,
	IconFilePlus,
	IconFileText,
	IconFileTypeCss,
	IconFileTypePdf,
	IconFileTypePpt,
	IconFileTypeXls,
	IconFileZip,
	IconFilter,
	IconFlag,
	IconFlag3,
	IconFlagFilled,
	IconFolder,
	IconFolderOpen,
	IconFolderPlus,
	IconGauge,
	IconGavel,
	IconGif,
	IconGripVertical,
	IconH1,
	IconH2,
	IconH3,
	IconHammer,
	IconHandClick,
	IconHandStop,
	IconHash,
	IconHeadset,
	IconHeart,
	IconHelpCircle,
	IconHighlight,
	IconHistory,
	IconId,
	IconIdBadge,
	IconInbox,
	IconIndentDecrease,
	IconIndentIncrease,
	IconInfoCircle,
	IconInfoCircleFilled,
	IconItalic,
	IconKey,
	IconKeyboard,
	IconLanguage,
	IconLayoutColumns,
	IconLayoutGrid,
	IconLayoutRows,
	IconLayoutSidebar,
	IconLeaf,
	IconLink,
	IconList,
	IconListCheck,
	IconListDetails,
	IconListNumbers,
	IconLoader2,
	IconLock,
	IconLockOpen,
	IconLockSquare,
	IconLogout,
	IconMagnet,
	IconMail,
	IconMailOpened,
	IconMapPin,
	IconMessage,
	IconMessageCircle,
	IconMicrophone,
	IconMicrophoneOff,
	IconMinimize,
	IconMinus,
	IconMoodSad,
	IconMoodSmile,
	IconMoon,
	IconMusic,
	IconNetworkOff,
	IconNews,
	IconNote,
	IconNotebook,
	IconPalette,
	IconPaperclip,
	IconPencil,
	IconPhone,
	IconPhoneCall,
	IconPhoneIncoming,
	IconPhoneOff,
	IconPhoneX,
	IconPhoto,
	IconPictureInPicture,
	IconPin,
	IconPinFilled,
	IconPinnedOff,
	IconPlane,
	IconPlayerPause,
	IconPlayerPauseFilled,
	IconPlayerPlay,
	IconPlayerPlayFilled,
	IconPlayerStop,
	IconPlug,
	IconPlus,
	IconPointer,
	IconQuestionMark,
	IconQuote,
	IconRefresh,
	IconRepeat,
	IconRewindBackward10,
	IconRewindForward10,
	IconRobot,
	IconRocket,
	IconRosetteDiscountCheck,
	IconRotate,
	IconRotateClockwise,
	IconRotateClockwise2,
	IconRubberStamp,
	IconScissors,
	IconSearch,
	IconSelect,
	IconSend,
	IconSettings,
	IconShare,
	IconShare2,
	IconShield,
	IconShieldExclamation,
	IconShoe,
	IconSignature,
	IconSnowflake,
	IconSortAscending,
	IconSparkles,
	IconSpeakerphone,
	IconSquare,
	IconSquareCheck,
	IconStack,
	IconStar,
	IconStarFilled,
	IconSticker2,
	IconStopwatch,
	IconStrikethrough,
	IconSun,
	IconSunrise,
	IconTag,
	IconTarget,
	IconTextColor,
	IconTicket,
	IconTool,
	IconTrash,
	IconTrees,
	IconTrendingUp,
	IconTypography,
	IconUnderline,
	IconUnlink,
	IconUpload,
	IconUser,
	IconUserCircle,
	IconUserCog,
	IconUserMinus,
	IconUserPlus,
	IconUsers,
	IconUsersGroup,
	IconVideo,
	IconVideoOff,
	IconVolume,
	IconVolume2,
	IconVolume3,
	IconVolumeOff,
	IconWand,
	IconWaveSine,
	IconWebhook,
	IconWifiOff,
	IconWorld,
	IconX,
	IconZoomIn,
	IconZoomOut,
	IconZzz,
} from '@tabler/icons-react';
import type {ComponentType, CSSProperties, ForwardRefExoticComponent, RefAttributes} from 'react';
import {createContext, forwardRef, useContext} from 'react';

export type IconWeight = 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';

export interface IconProps extends Omit<TablerIconProps, 'size' | 'color' | 'stroke'> {
	size?: number | string;
	color?: string;
	weight?: IconWeight;
	mirrored?: boolean;
	alt?: string;
}

export type Icon = ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>>;

export const IconContext = createContext<Partial<Pick<IconProps, 'size' | 'color' | 'weight' | 'mirrored'>>>({});

const STROKE: Record<IconWeight, number> = {thin: 1, light: 1.25, regular: 1.75, bold: 2.25, fill: 2.25, duotone: 1.75};

type TablerIcon = ComponentType<TablerIconProps & RefAttributes<SVGSVGElement>>;

function make(name: string, Outline: TablerIcon, Solid?: TablerIcon): Icon {
	const Component = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
		const context = useContext(IconContext);
		const {size, color, weight, mirrored, style, alt, ...rest} = {...context, ...props};
		const resolvedWeight = weight ?? 'regular';
		const Rendered = resolvedWeight === 'fill' && Solid ? Solid : Outline;
		const mirroredStyle: CSSProperties | undefined = mirrored ? {transform: 'scaleX(-1)', ...style} : style;
		return (
			<Rendered
				ref={ref}
				size={size ?? 24}
				color={color ?? 'currentColor'}
				stroke={STROKE[resolvedWeight]}
				style={mirroredStyle}
				aria-label={alt}
				aria-hidden={alt ? undefined : true}
				{...rest}
			/>
		);
	});
	Component.displayName = name;
	return Component;
}

/** A quiet home outline without a door, window, or other centre detail. */
const HouseIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	const context = useContext(IconContext);
	const {size, color, weight, mirrored, style, alt, ...rest} = {...context, ...props};
	const resolvedWeight = weight ?? 'regular';
	const mirroredStyle: CSSProperties | undefined = mirrored ? {transform: 'scaleX(-1)', ...style} : style;
	return (
		<svg
			ref={ref}
			width={size ?? 24}
			height={size ?? 24}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color ?? 'currentColor'}
			strokeWidth={STROKE[resolvedWeight]}
			strokeLinecap="round"
			strokeLinejoin="round"
			style={mirroredStyle}
			aria-label={alt}
			aria-hidden={alt ? undefined : true}
			{...rest}
		>
			<path d="M5 12H3l9-9 9 9h-2" />
			<path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7" />
		</svg>
	);
});
HouseIcon.displayName = 'HouseIcon';

export const AirplaneTiltIcon = make('AirplaneTiltIcon', IconPlane);
export const AppWindowIcon = make('AppWindowIcon', IconAppWindow);
export const AppleLogoIcon = make('AppleLogoIcon', IconBrandApple);
export const ArchiveIcon = make('ArchiveIcon', IconArchive);
export const ArrowBendDoubleUpLeftIcon = make('ArrowBendDoubleUpLeftIcon', IconArrowBackUpDouble);
export const ArrowBendUpLeftIcon = make('ArrowBendUpLeftIcon', IconArrowBackUp);
export const ArrowBendUpRightIcon = make('ArrowBendUpRightIcon', IconArrowForwardUp);
export const ArrowClockwiseIcon = make('ArrowClockwiseIcon', IconRefresh);
export const ArrowCounterClockwiseIcon = make('ArrowCounterClockwiseIcon', IconArrowBack);
export const ArrowDownIcon = make('ArrowDownIcon', IconArrowDown);
export const ArrowFatUpIcon = make('ArrowFatUpIcon', IconArrowBigUp);
export const ArrowLeftIcon = make('ArrowLeftIcon', IconArrowLeft);
export const ArrowRightIcon = make('ArrowRightIcon', IconArrowRight);
export const ArrowSquareInIcon = make('ArrowSquareInIcon', IconArrowsDiagonalMinimize);
export const ArrowSquareOutIcon = make('ArrowSquareOutIcon', IconExternalLink);
export const ArrowUpIcon = make('ArrowUpIcon', IconArrowUp);
export const ArrowsClockwiseIcon = make('ArrowsClockwiseIcon', IconRefresh);
export const ArrowsCounterClockwiseIcon = make('ArrowsCounterClockwiseIcon', IconRotateClockwise2);
export const ArrowsDiagonalIcon = make('ArrowsDiagonalIcon', IconArrowsDiagonal);
export const ArrowsDiagonalMinimizeIcon = make('ArrowsDiagonalMinimizeIcon', IconArrowsDiagonalMinimize2);
export const ArrowsDownUpIcon = make('ArrowsDownUpIcon', IconArrowsVertical);
export const ArrowsInIcon = make('ArrowsInIcon', IconArrowsMinimize);
export const ArrowsInSimpleIcon = make('ArrowsInSimpleIcon', IconMinimize);
export const ArrowsLeftRightIcon = make('ArrowsLeftRightIcon', IconArrowsHorizontal);
export const ArrowsOutCardinalIcon = make('ArrowsOutCardinalIcon', IconArrowsMove);
export const ArrowsOutIcon = make('ArrowsOutIcon', IconArrowsMaximize);
export const AtIcon = make('AtIcon', IconAt);
export const AtSlashIcon = make('AtSlashIcon', IconAtOff);
export const BellIcon = make('BellIcon', IconBell);
export const BellRingingIcon = make('BellRingingIcon', IconBellRinging);
export const BellSlashIcon = make('BellSlashIcon', IconBellOff);
export const BicycleIcon = make('BicycleIcon', IconBike);
export const BookOpenIcon = make('BookOpenIcon', IconBook2);
export const BookmarkSimpleIcon = make('BookmarkSimpleIcon', IconBookmark);
export const BootIcon = make('BootIcon', IconShoe);
export const BowlFoodIcon = make('BowlFoodIcon', IconBowlChopsticks);
export const BrainIcon = make('BrainIcon', IconBrain);
export const BriefcaseIcon = make('BriefcaseIcon', IconBriefcase);
export const BrowserIcon = make('BrowserIcon', IconBrowser);
export const BugBeetleIcon = make('BugBeetleIcon', IconBug);
export const BugIcon = make('BugIcon', IconBug);
export const BuildingsIcon = make('BuildingsIcon', IconBuilding);
export const CakeIcon = make('CakeIcon', IconCake);
export const CalendarBlankIcon = make('CalendarBlankIcon', IconCalendar, IconCalendarFilled);
export const CalendarCheckIcon = make('CalendarCheckIcon', IconCalendarCheck);
export const CalendarPlusIcon = make('CalendarPlusIcon', IconCalendarPlus);
export const CalendarDotsIcon = make('CalendarDotsIcon', IconCalendar, IconCalendarFilled);
export const CameraIcon = make('CameraIcon', IconCamera);
export const ClosedCaptionsIcon = make('ClosedCaptionsIcon', IconBadgeCc);
export const CameraSlashIcon = make('CameraSlashIcon', IconCameraOff);
export const CaretDownIcon = make('CaretDownIcon', IconChevronDown);
export const CaretLeftIcon = make('CaretLeftIcon', IconChevronLeft);
export const CaretRightIcon = make('CaretRightIcon', IconChevronRight);
export const CaretUpIcon = make('CaretUpIcon', IconChevronUp);
export const ChalkboardIcon = make('ChalkboardIcon', IconChalkboard);
export const ChartBarIcon = make('ChartBarIcon', IconChartBar);
export const ChartLineIcon = make('ChartLineIcon', IconChartLine);
export const ChatCenteredDotsIcon = make('ChatCenteredDotsIcon', IconMessageCircle);
export const ChatCircleDotsIcon = make('ChatCircleDotsIcon', IconMessageCircle);
export const ChatCircleIcon = make('ChatCircleIcon', IconMessageCircle);
export const ChatCircleTextIcon = make('ChatCircleTextIcon', IconMessageCircle);
export const ChatTeardropIcon = make('ChatTeardropIcon', IconMessage);
export const CheckCircleIcon = make('CheckCircleIcon', IconCircleCheck, IconCircleCheckFilled);
export const CheckIcon = make('CheckIcon', IconCheck);
export const CheckSquareIcon = make('CheckSquareIcon', IconSquareCheck);
export const ChecksIcon = make('ChecksIcon', IconChecks);
export const CircleIcon = make('CircleIcon', IconCircle);
export const CircleDashedIcon = make('CircleDashedIcon', IconCircleDashed);
export const CircleDotIcon = make('CircleDotIcon', IconCircleDot);
export const CircleNotchIcon = make('CircleNotchIcon', IconLoader2);
export const ClipboardIcon = make('ClipboardIcon', IconClipboard);
export const ClipboardTextIcon = make('ClipboardTextIcon', IconClipboardText);
export const ClockClockwiseIcon = make('ClockClockwiseIcon', IconRotateClockwise);
export const ClockCounterClockwiseIcon = make('ClockCounterClockwiseIcon', IconHistory);
export const ClockIcon = make('ClockIcon', IconClock);
export const CloudFogIcon = make('CloudFogIcon', IconCloudFog);
export const CloudIcon = make('CloudIcon', IconCloud);
export const CloudLightningIcon = make('CloudLightningIcon', IconCloudStorm);
export const CloudRainIcon = make('CloudRainIcon', IconCloudRain);
export const CloudSlashIcon = make('CloudSlashIcon', IconCloudOff);
export const CloudSnowIcon = make('CloudSnowIcon', IconCloudSnow);
export const CloudSunIcon = make('CloudSunIcon', IconSun);
export const CodeIcon = make('CodeIcon', IconCode);
export const CompassIcon = make('CompassIcon', IconCompass);
export const CopyIcon = make('CopyIcon', IconCopy);
export const CopySimpleIcon = make('CopySimpleIcon', IconCopy);
export const CornersInIcon = make('CornersInIcon', IconArrowsMinimize);
export const CornersOutIcon = make('CornersOutIcon', IconArrowsMaximize);
export const CrownIcon = make('CrownIcon', IconCrown);
export const CursorIcon = make('CursorIcon', IconPointer);
export const DesktopIcon = make('DesktopIcon', IconDeviceDesktop);
export const DeviceMobileIcon = make('DeviceMobileIcon', IconDeviceMobile);
export const DeviceRotateIcon = make('DeviceRotateIcon', IconDeviceMobileRotated);
export const VibrateIcon = make('VibrateIcon', IconDeviceMobileVibration);
export const DevicesIcon = make('DevicesIcon', IconDevices);
export const DotsSixVerticalIcon = make('DotsSixVerticalIcon', IconGripVertical);
export const DotsThreeIcon = make('DotsThreeIcon', IconDots);
export const DotsThreeOutlineIcon = make('DotsThreeOutlineIcon', IconDots);
export const DotsThreeVerticalIcon = make('DotsThreeVerticalIcon', IconDotsVertical);
export const DownloadIcon = make('DownloadIcon', IconDownload);
export const DownloadSimpleIcon = make('DownloadSimpleIcon', IconDownload);
export const DropIcon = make('DropIcon', IconDroplet);
export const EnvelopeOpenIcon = make('EnvelopeOpenIcon', IconMailOpened);
export const EnvelopeSimpleIcon = make('EnvelopeSimpleIcon', IconMail);
export const EnvelopeSimpleOpenIcon = make('EnvelopeSimpleOpenIcon', IconMailOpened);
export const EraserIcon = make('EraserIcon', IconEraser);
export const ExclamationMarkIcon = make('ExclamationMarkIcon', IconExclamationMark);
export const EyeIcon = make('EyeIcon', IconEye);
export const EyeSlashIcon = make('EyeSlashIcon', IconEyeOff);
export const EyedropperIcon = make('EyedropperIcon', IconColorPicker);
export const FileArchiveIcon = make('FileArchiveIcon', IconFileZip);
export const FileAudioIcon = make('FileAudioIcon', IconFileMusic);
export const FileCodeIcon = make('FileCodeIcon', IconFileCode);
export const FileCssIcon = make('FileCssIcon', IconFileTypeCss);
export const FeatherIcon = make('FeatherIcon', IconFeather);
export const FileIcon = make('FileIcon', IconFile);
export const FileImageIcon = make('FileImageIcon', IconPhoto);
export const FilePdfIcon = make('FilePdfIcon', IconFileTypePdf);
export const FilePlusIcon = make('FilePlusIcon', IconFilePlus);
export const FilePptIcon = make('FilePptIcon', IconFileTypePpt);
export const FileTextIcon = make('FileTextIcon', IconFileText);
export const FileVideoIcon = make('FileVideoIcon', IconVideo);
export const FileXlsIcon = make('FileXlsIcon', IconFileTypeXls);
export const FileZipIcon = make('FileZipIcon', IconFileZip);
export const FlagCheckeredIcon = make('FlagCheckeredIcon', IconFlag3);
export const FlagIcon = make('FlagIcon', IconFlag, IconFlagFilled);
export const FloppyDiskIcon = make('FloppyDiskIcon', IconDeviceFloppy);
export const FolderIcon = make('FolderIcon', IconFolder);
export const FolderOpenIcon = make('FolderOpenIcon', IconFolderOpen);
export const FolderPlusIcon = make('FolderPlusIcon', IconFolderPlus);
export const FolderSimpleIcon = make('FolderSimpleIcon', IconFolder);
export const FunnelIcon = make('FunnelIcon', IconFilter);
export const FunnelSimpleIcon = make('FunnelSimpleIcon', IconFilter);
export const GameControllerIcon = make('GameControllerIcon', IconDeviceGamepad2);
export const GaugeIcon = make('GaugeIcon', IconGauge);
export const GavelIcon = make('GavelIcon', IconGavel);
export const GearIcon = make('GearIcon', IconSettings);
export const GifIcon = make('GifIcon', IconGif);
export const GithubLogoIcon = make('GithubLogoIcon', IconBrandGithub);
export const MagicWandIcon = make('MagicWandIcon', IconWand);
export const NewspaperIcon = make('NewspaperIcon', IconNews);
export const RocketIcon = make('RocketIcon', IconRocket);
export const GlobeHemisphereWestIcon = make('GlobeHemisphereWestIcon', IconWorld);
export const GlobeIcon = make('GlobeIcon', IconWorld);
export const GlobeSimpleIcon = make('GlobeSimpleIcon', IconWorld);
export const GridFourIcon = make('GridFourIcon', IconLayoutGrid);
export const HammerIcon = make('HammerIcon', IconHammer);
export const HandIcon = make('HandIcon', IconHandStop);
export const HandTapIcon = make('HandTapIcon', IconHandClick);
export const HashIcon = make('HashIcon', IconHash);
export const HeadsetIcon = make('HeadsetIcon', IconHeadset);
export const HeartIcon = make('HeartIcon', IconHeart);
export {HouseIcon};
export const HighlighterIcon = make('HighlighterIcon', IconHighlight);
export const IdentificationBadgeIcon = make('IdentificationBadgeIcon', IconIdBadge);
export const IdentificationCardIcon = make('IdentificationCardIcon', IconId);
export const ImageIcon = make('ImageIcon', IconPhoto);
export const ImageSquareIcon = make('ImageSquareIcon', IconPhoto);
export const InfoIcon = make('InfoIcon', IconInfoCircle, IconInfoCircleFilled);
export const KanbanIcon = make('KanbanIcon', IconLayoutColumns);
export const KeyIcon = make('KeyIcon', IconKey);
export const KeyboardIcon = make('KeyboardIcon', IconKeyboard);
export const LeafIcon = make('LeafIcon', IconLeaf);
export const LightbulbFilamentIcon = make('LightbulbFilamentIcon', IconBulb);
export const LinkBreakIcon = make('LinkBreakIcon', IconUnlink);
export const LinkIcon = make('LinkIcon', IconLink);
export const LinkSimpleIcon = make('LinkSimpleIcon', IconLink);
export const LinuxLogoIcon = make('LinuxLogoIcon', IconBrandUbuntu);
export const ListBulletsIcon = make('ListBulletsIcon', IconList);
export const ListChecksIcon = make('ListChecksIcon', IconListCheck);
export const ListIcon = make('ListIcon', IconList);
export const ListNumbersIcon = make('ListNumbersIcon', IconListNumbers);
export const ListPlusIcon = make('ListPlusIcon', IconListDetails);
export const LockIcon = make('LockIcon', IconLock);
export const LockKeyIcon = make('LockKeyIcon', IconLockSquare);
export const LockSimpleIcon = make('LockSimpleIcon', IconLock);
export const LockSimpleOpenIcon = make('LockSimpleOpenIcon', IconLockOpen);
export const MagnetIcon = make('MagnetIcon', IconMagnet);
export const MagnifyingGlassIcon = make('MagnifyingGlassIcon', IconSearch);
export const MagnifyingGlassMinusIcon = make('MagnifyingGlassMinusIcon', IconZoomOut);
export const MagnifyingGlassPlusIcon = make('MagnifyingGlassPlusIcon', IconZoomIn);
export const MapPinIcon = make('MapPinIcon', IconMapPin);
export const MegaphoneIcon = make('MegaphoneIcon', IconSpeakerphone);
export const MicrophoneIcon = make('MicrophoneIcon', IconMicrophone);
export const MicrophoneSlashIcon = make('MicrophoneSlashIcon', IconMicrophoneOff);
export const MinusCircleIcon = make('MinusCircleIcon', IconCircleMinus);
export const MinusIcon = make('MinusIcon', IconMinus);
export const MonitorIcon = make('MonitorIcon', IconDeviceDesktop);
export const MonitorPlayIcon = make('MonitorPlayIcon', IconDeviceTv);
export const MoonIcon = make('MoonIcon', IconMoon);
export const MusicNoteIcon = make('MusicNoteIcon', IconMusic);
export const NetworkSlashIcon = make('NetworkSlashIcon', IconNetworkOff);
export const NoteIcon = make('NoteIcon', IconNote);
export const NotePencilIcon = make('NotePencilIcon', IconEdit);
export const NotebookIcon = make('NotebookIcon', IconNotebook);
export const PaintBrushBroadIcon = make('PaintBrushBroadIcon', IconBrush);
export const PaintBrushIcon = make('PaintBrushIcon', IconBrush);
export const PaletteIcon = make('PaletteIcon', IconPalette);
export const PaperPlaneIcon = make('PaperPlaneIcon', IconSend);
export const PaperPlaneRightIcon = make('PaperPlaneRightIcon', IconSend);
export const PaperclipIcon = make('PaperclipIcon', IconPaperclip);
export const PauseIcon = make('PauseIcon', IconPlayerPause);
export const PauseSolidIcon = make('PauseSolidIcon', IconPlayerPauseFilled);
export const PencilIcon = make('PencilIcon', IconPencil);
export const PencilSimpleIcon = make('PencilSimpleIcon', IconPencil);
export const PencilSimpleLineIcon = make('PencilSimpleLineIcon', IconPencil);
export const PersonSimpleCircleIcon = make('PersonSimpleCircleIcon', IconAccessible);
export const PhoneCallIcon = make('PhoneCallIcon', IconPhoneCall);
export const PhoneDisconnectIcon = make('PhoneDisconnectIcon', IconPhoneOff);
export const PhoneIcon = make('PhoneIcon', IconPhone);
export const PhoneIncomingIcon = make('PhoneIncomingIcon', IconPhoneIncoming);
export const PhoneXIcon = make('PhoneXIcon', IconPhoneX);
export const PictureInPictureIcon = make('PictureInPictureIcon', IconPictureInPicture);
export const PlayIcon = make('PlayIcon', IconPlayerPlay);
export const PlaySolidIcon = make('PlaySolidIcon', IconPlayerPlayFilled);
export const PlugIcon = make('PlugIcon', IconPlug);
export const PlusCircleIcon = make('PlusCircleIcon', IconCirclePlus);
export const PlusIcon = make('PlusIcon', IconPlus);
export const ProhibitIcon = make('ProhibitIcon', IconBan);
export const PushPinIcon = make('PushPinIcon', IconPin, IconPinFilled);
export const PushPinSlashIcon = make('PushPinSlashIcon', IconPinnedOff);
export const QuestionIcon = make('QuestionIcon', IconHelpCircle);
export const QuestionMarkIcon = make('QuestionMarkIcon', IconQuestionMark);
export const QuotesIcon = make('QuotesIcon', IconQuote);
export const RepeatIcon = make('RepeatIcon', IconRepeat);
export const ReplayIcon = make('ReplayIcon', IconRotate);
export const RewindBackTenIcon = make('RewindBackTenIcon', IconRewindBackward10);
export const RewindForwardTenIcon = make('RewindForwardTenIcon', IconRewindForward10);
export const RobotIcon = make('RobotIcon', IconRobot);
export const RowsIcon = make('RowsIcon', IconLayoutRows);
export const ScissorsIcon = make('ScissorsIcon', IconScissors);
export const SealCheckIcon = make('SealCheckIcon', IconRosetteDiscountCheck);
export const SelectionIcon = make('SelectionIcon', IconSelect);
export const ShareFatIcon = make('ShareFatIcon', IconShare2);
export const ShareNetworkIcon = make('ShareNetworkIcon', IconShare);
export const ShieldIcon = make('ShieldIcon', IconShield);
export const ShieldWarningIcon = make('ShieldWarningIcon', IconShieldExclamation);
export const SidebarSimpleIcon = make('SidebarSimpleIcon', IconLayoutSidebar);
export const SignOutIcon = make('SignOutIcon', IconLogout);
export const SignatureIcon = make('SignatureIcon', IconSignature);
export const SlidersHorizontalIcon = make('SlidersHorizontalIcon', IconAdjustmentsHorizontal);
export const SmileyIcon = make('SmileyIcon', IconMoodSmile);
export const SmileySadIcon = make('SmileySadIcon', IconMoodSad);
export const SnowflakeIcon = make('SnowflakeIcon', IconSnowflake);
export const SortAscendingIcon = make('SortAscendingIcon', IconSortAscending);
export const SparkleIcon = make('SparkleIcon', IconSparkles);
export const SpeakerHighIcon = make('SpeakerHighIcon', IconVolume);
export const SpeakerLowIcon = make('SpeakerLowIcon', IconVolume2);
export const SpeakerNoneIcon = make('SpeakerNoneIcon', IconVolume3);
export const SpeakerSimpleSlashIcon = make('SpeakerSimpleSlashIcon', IconVolumeOff);
export const SpeakerSlashIcon = make('SpeakerSlashIcon', IconVolumeOff);
export const SpeakerXIcon = make('SpeakerXIcon', IconVolumeOff);
export const SquareIcon = make('SquareIcon', IconSquare);
export const StackSimpleIcon = make('StackSimpleIcon', IconStack);
export const StampIcon = make('StampIcon', IconRubberStamp);
export const StarIcon = make('StarIcon', IconStar, IconStarFilled);
export const StickerIcon = make('StickerIcon', IconSticker2);
export const StopCircleIcon = make('StopCircleIcon', IconPlayerStop);
export const StopIcon = make('StopIcon', IconPlayerStop);
export const SunHorizonIcon = make('SunHorizonIcon', IconSunrise);
export const SunIcon = make('SunIcon', IconSun);
export const TagIcon = make('TagIcon', IconTag);
export const TargetIcon = make('TargetIcon', IconTarget);
export const TextAaIcon = make('TextAaIcon', IconTypography);
export const TextAlignCenterIcon = make('TextAlignCenterIcon', IconAlignCenter);
export const TextAlignLeftIcon = make('TextAlignLeftIcon', IconAlignLeft);
export const TextAlignRightIcon = make('TextAlignRightIcon', IconAlignRight);
export const TextBIcon = make('TextBIcon', IconBold);
export const TextColorIcon = make('TextColorIcon', IconTextColor);
export const TextHOneIcon = make('TextHOneIcon', IconH1);
export const TextHTwoIcon = make('TextHTwoIcon', IconH2);
export const TextHThreeIcon = make('TextHThreeIcon', IconH3);
export const TextIndentIcon = make('TextIndentIcon', IconIndentIncrease);
export const TextItalicIcon = make('TextItalicIcon', IconItalic);
export const TextOutdentIcon = make('TextOutdentIcon', IconIndentDecrease);
export const TextStrikethroughIcon = make('TextStrikethroughIcon', IconStrikethrough);
export const TextTIcon = make('TextTIcon', IconTypography);
export const TextUnderlineIcon = make('TextUnderlineIcon', IconUnderline);
export const TicketIcon = make('TicketIcon', IconTicket);
export const TimerIcon = make('TimerIcon', IconStopwatch);
export const TranslateIcon = make('TranslateIcon', IconLanguage);
export const TrashIcon = make('TrashIcon', IconTrash);
// KONVO: Home's source rail, everything in one list.
export const TrayIcon = make('TrayIcon', IconInbox);
export const TrashSimpleIcon = make('TrashSimpleIcon', IconTrash);
export const TreePalmIcon = make('TreePalmIcon', IconTrees);
export const TrendUpIcon = make('TrendUpIcon', IconTrendingUp);
export const UploadIcon = make('UploadIcon', IconUpload);
export const UploadSimpleIcon = make('UploadSimpleIcon', IconUpload);
export const UserCircleIcon = make('UserCircleIcon', IconUserCircle);
export const UserCirclePlusIcon = make('UserCirclePlusIcon', IconUserPlus);
export const UserGearIcon = make('UserGearIcon', IconUserCog);
export const UserIcon = make('UserIcon', IconUser);
export const UserListIcon = make('UserListIcon', IconUsersGroup);
export const UserMinusIcon = make('UserMinusIcon', IconUserMinus);
export const UserPlusIcon = make('UserPlusIcon', IconUserPlus);
export const UsersIcon = make('UsersIcon', IconUsers);
export const UsersThreeIcon = make('UsersThreeIcon', IconUsersGroup);
export const VideoCameraIcon = make('VideoCameraIcon', IconVideo);
export const VideoCameraSlashIcon = make('VideoCameraSlashIcon', IconVideoOff);
export const VideoIcon = make('VideoIcon', IconVideo);
export const WarningCircleIcon = make('WarningCircleIcon', IconAlertCircle, IconAlertCircleFilled);
export const WarningIcon = make('WarningIcon', IconAlertTriangle, IconAlertTriangleFilled);
export const WarningOctagonIcon = make('WarningOctagonIcon', IconAlertOctagon);
export const WaveformIcon = make('WaveformIcon', IconWaveSine);
export const WebhooksLogoIcon = make('WebhooksLogoIcon', IconWebhook);
export const WifiSlashIcon = make('WifiSlashIcon', IconWifiOff);
export const WindowsLogoIcon = make('WindowsLogoIcon', IconBrandWindows);
export const WrenchIcon = make('WrenchIcon', IconTool);
export const XCircleIcon = make('XCircleIcon', IconCircleX, IconCircleXFilled);
export const XIcon = make('XIcon', IconX);
export const ZzzIcon = make('ZzzIcon', IconZzz);
